import {AppLanguageCode} from '../shared/i18n/app-language';

export const LANDING_SEO: Record<AppLanguageCode, {title: string; description: string}> = {
  uk: {
    title: 'Облік речей і QR-мітки для дому — Invemory',
    description: 'Ведіть домашній облік речей у Invemory: зберігайте місця розташування, позначайте коробки QR-кодами та знаходьте потрібне. Доступно у браузері й на Android.',
  },
  en: {
    title: 'Home inventory app with QR labels — Invemory',
    description: 'Keep a home inventory with Invemory: record storage locations, label boxes with QR codes, and find your belongings. Available on the web and Android.',
  },
  de: {
    title: 'Hausinventar-App mit QR-Etiketten — Invemory',
    description: 'Verwalten Sie Ihr Hausinventar mit Invemory: Aufbewahrungsorte erfassen, Kisten mit QR-Codes beschriften und Gegenstände finden. Im Web und auf Android.',
  },
  ru: {
    title: 'Учёт вещей и QR-метки для дома — Invemory',
    description: 'Ведите домашний учёт вещей в Invemory: сохраняйте места хранения, отмечайте коробки QR-кодами и находите нужное. Доступно в браузере и на Android.',
  },
};
